export default "__VITE_ASSET__B88NW1_o__"